import { useState } from "react";
import Title from "../shared/components/Title";
import { DashboardTabContent } from "../features/qbr-dashboard/components/DashboardTabContent";
import { EmptyState } from "../features/qbr-dashboard/components/EmptyState";
import { FiltersPanel } from "../features/qbr-dashboard/components/FiltersPanel";
import { SummaryCardsRow } from "../features/qbr-dashboard/components/SummaryCardsRow";
import { TabsNav } from "../features/qbr-dashboard/components/TabsNav";
import { useQbrBreakdowns } from "../features/qbr-dashboard/hooks/useQbrBreakdowns";
import { useQbrCharts } from "../features/qbr-dashboard/hooks/useQbrCharts";
import { useQbrFilters } from "../features/qbr-dashboard/hooks/useQbrFilters";
import { useQbrSummary } from "../features/qbr-dashboard/hooks/useQbrSummary";
import { useQbrSurchargeTrends } from "../features/qbr-dashboard/hooks/useQbrSurchargeTrends";
import { useVisibleTables } from "../features/qbr-dashboard/hooks/useVisibleTables";

export default function QbrDashboard() {
  const [activeTab, setActiveTab] = useState("summary");

  const {
    filters,
    options,
    isFiltersLoading,
    error: filtersError,
    quarterOptions,
    childCompanyOptions,
    serviceOptions,
    canLoadData,
    handleSingleChange,
    handleMultiChange,
    handleYearChange,
    handleParentCompanyChange,
    handleCarrierChange,
    resetFilters,
  } = useQbrFilters();

  const { summary, isSummaryLoading, error: summaryError } = useQbrSummary(filters, canLoadData);
  const { tableData, tableLoading, error: breakdownsError } = useQbrBreakdowns(filters, canLoadData);
  const { surchargeTrends, isTrendsLoading } = useQbrSurchargeTrends(filters, canLoadData);
  const { charts, isChartsLoading } = useQbrCharts(filters, canLoadData);
  const visibleTables = useVisibleTables(activeTab);

  const errorMessage = filtersError || summaryError || breakdownsError;

  return (
    <div className="min-h-screen px-1 pb-10">
      <Title title="QBR Dashboard" />

      <FiltersPanel
        filters={filters}
        options={options}
        quarterOptions={quarterOptions}
        childCompanyOptions={childCompanyOptions}
        serviceOptions={serviceOptions}
        isFiltersLoading={isFiltersLoading}
        canLoadData={canLoadData}
        errorMessage={errorMessage}
        onYearChange={handleYearChange}
        onQuarterChange={handleSingleChange("financialQuarter")}
        onParentCompanyChange={handleParentCompanyChange}
        onChildCompanyChange={handleMultiChange("childCompany")}
        onCarrierChange={handleCarrierChange}
        onServiceChange={handleMultiChange("service")}
        onReset={resetFilters}
      />

      {!canLoadData ? (
        <div className="mt-6">
          <EmptyState message="Select Financial Year and Financial Quarter to load DIFOT visualisation data." />
        </div>
      ) : (
        <>
          <SummaryCardsRow summary={summary} isSummaryLoading={isSummaryLoading} />
          <TabsNav activeTab={activeTab} onChange={setActiveTab} />
          <DashboardTabContent
            activeTab={activeTab}
            tableData={tableData}
            tableLoading={tableLoading}
            surchargeTrends={surchargeTrends}
            isTrendsLoading={isTrendsLoading}
            charts={charts}
            isChartsLoading={isChartsLoading}
            visibleTables={visibleTables}
          />
        </>
      )}
    </div>
  );
}
